const suppliers = {
  toast: {
    error: {
      badResponse: '[Fleet] bad server response',
      create: {},
      edit: {},
    },
    success: {
      create: {
        default: '[Fleet] has been created successfully',
      },
      edit: {},
    },
  },
  table: {
    headers: {
      name: 'Fleet Name',
    },
  },
  create: {
    successToast: {
      message: 'Success! Fleet Created!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Create Fleet',
    },
  },

  edit: {
    successToast: {
      message: 'Success! Fleet Updated!',
    },
    errorToast: {
      message: 'Error occurred. Could Not Update Fleet',
    },
  },

  deleteModal: {
    header: 'Delete Fleets',
    body: 'You are about to delete {{num}} Fleets.',
  },

  deleteToast: 'Can\'t delete fleets',

  forms: {
    information: {
      rank: {
        header: 'Fleet Rank and Score',
      },
      supplierKpis: {
        header: 'Fleet KPIs',
      },
    },
  },
  delete: {
    confirmation: {
      header: 'Delete Fleet confirmation',
      body: 'Fleet were deleted successfully',
    },
  },
};

export default suppliers;
